module.exports = __webpack_public_path__ + "img/shopping-cart.0f8f31bc.svg";